import { Box, Hidden } from '@mui/material'
import React from 'react'
import Carousel from 'react-material-ui-carousel'
import { connect } from 'react-redux'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import State from 'states/types'
import { mapOperationsToDispatchProps } from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
  }
}

type AppProps = StateProps & DispatchProps

const CarouselFC: React.FC<any> = (props: AppProps) => {
  console.log(props.layout.language.name)

  return (
    <Box
      justifyContent={'center'}
      display={'flex'}
      alignItems={'center'}
      height={500}
      width={0.95}
      marginX={'auto'}
    >
      <Carousel
        height={500}
        autoPlay={true}
        cycleNavigation={true}
        sx={{ width: '100%', maxWidth: '92vw' }}
        animation={'slide'}
        indicators={false}
        duration={5000}
        interval={10000}
      >
        <Box display={'flex'} justifyContent={'space-evenly'}>
          <img
            src={
              'https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/scandinavian-design-trends-lead-1574282270.jpg'
            }
            alt={'sample'}
            width={'auto'}
            height={450}
            style={{
              animation: 'bubble 12.5s ease-in-out infinite',
              maxWidth: '92vw'
            }}
          />
          <Hidden xlDown>
            <img
              src={
                'https://renopedia.sg/wp-content/uploads/2022/07/Picture1.png'
              }
              alt={'sample'}
              width={'auto'}
              height={450}
              style={{
                animation: 'bubble 10s ease-in-out infinite',
                maxWidth: '92vw'
              }}
            />
          </Hidden>
        </Box>
        <Box display={'flex'} justifyContent={'space-evenly'}>
          <img
            src={
              'https://www.homelane.com/blog/wp-content/uploads/2022/08/shutterstock_1825888148-3.jpg'
            }
            alt={'sample'}
            width={'auto'}
            height={450}
            style={{
              animation: 'bubble 12.5s ease-in-out infinite',
              maxWidth: '92vw'
            }}
          />
          <Hidden xlDown>
            <img
              src={
                'https://www.decorilla.com/online-decorating/wp-content/uploads/2020/08/Light-and-airy-living-dining-combo-with-Scandinavian-decor-elements.jpg'
              }
              alt={'sample'}
              width={'auto'}
              height={450}
              style={{
                animation: 'bubble 10s ease-in-out infinite',
                maxWidth: '92vw'
              }}
            />
          </Hidden>
        </Box>
        <Box display={'flex'} justifyContent={'space-evenly'}>
          <img
            src={
              'https://media.architecturaldigest.com/photos/578564fff5b3b150126f0781/master/pass/modern-pools-004.jpg'
            }
            alt={'sample'}
            width={'auto'}
            height={450}
            style={{
              animation: 'bubble 12.5s ease-in-out infinite',
              maxWidth: '92vw'
            }}
          />
          <Hidden xlDown>
            <img
              src={
                'https://i.pinimg.com/originals/87/22/e4/8722e44955ec670cbf8d0bbb3cfa7061.jpg'
              }
              alt={'sample'}
              width={'auto'}
              height={450}
              style={{
                animation: 'bubble 10s ease-in-out infinite',
                maxWidth: '92vw'
              }}
            />
          </Hidden>
        </Box>
      </Carousel>
    </Box>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations
})

const NivosCarousel = connect(mapStateToProps, mapDispatchToProps)(CarouselFC)

export default NivosCarousel
